$.each([
    $(".wedding-service-intro .intro-text h2.section-title"),
    $(".wedding-service-intro .intro-text .cms-content"),
], function(i, v){
    $(this).attr({
        'data-aos': "gentle-up",
        'data-aos-anchor': ".intro-text",
        'data-aos-anchor-placement': "top-bottom",
        'data-aos-duration': 1500,
        'data-aos-delay': 600 + i*300,
    });
})

$(".big-visual-banner-holder").attr({
    'data-aos': "gentle-up",
    'data-aos-duration': 1000,
    'data-aos-delay': 600,
});

var pageSectionList = $(".page-section-list");

function syncActiveLine(){
	var array = [];
	$(".section .anchor").each(function(){
		if(scrollTop >= Math.floor($(this).offset().top)){
			array.push($(this).attr('id'));
		}
	})
	
	$("[data-to-section='" + array[array.length - 1] + "']").parent().addClass('active').siblings().removeClass('active');
	var offsetTop = pageSectionList.offset().top;
	$(".border-placer .topline").css('top', $("li.active", pageSectionList).offset().top - offsetTop);
	$(".border-placer .btmline").css('top', $("li.active", pageSectionList).offset().top + $("li.active", pageSectionList).outerHeight() - offsetTop);
}

if(pageSectionList.length){
	syncActiveLine();
	$(window).on('resize', syncActiveLine);
	$(window).on('scroll', syncActiveLine);
}

$("[data-to-section]").click(function(e){
    var elem = $(this).data("to-section");
    if($("#" + elem).length) $.scrollTo($("#" + elem), {
    	duration: 1500,
    	onAfter: syncActiveLine()
    });
})


$(window).resize(function(){
	$("main").css('padding-top', $(".inner-banner").outerHeight());
}).trigger('resize');



var viewportEffect = viewport().width >= 992 ? 'desktop' : 'mobile';
var scrollMagicController;
var scrollScene = [];
var scrollSceneElem = [];


function desktopScrollMagic(){
	scrollMagicController = new ScrollMagic.Controller();

	var tween = new TimelineMax ()
	.add([
		TweenMax.fromTo(".inner-banner", {y:0}, {y: "-50%", duration:1, ease: Linear.easeNone}),
	])

	var scene = new ScrollMagic.Scene({
		triggerElement: "main",
		triggerHook: 0,
		duration: "100%",
	})
	.setTween(tween)
	.addTo(scrollMagicController);

	scrollScene.push(scene);
	scrollSceneElem.push('.inner-banner');

	var tween = new TimelineMax ()
	.add([
		TweenMax.fromTo(".style-1 .vertical-title", {y:-50, opacity:0}, {y: 0, opacity:1, duration:1, ease: Linear.easeNone}),
	])
	.add([
		TweenMax.fromTo(".style-1 .txt", {opacity:0}, {opacity:1, duration:1, ease: Linear.easeNone}),
	], "-=0.1")

	var scene = new ScrollMagic.Scene({
		triggerElement: ".style-1",
		triggerHook: .8,
		duration: "50%",
	})
	.setTween(tween)
	.addTo(scrollMagicController);

	scrollScene.push(scene);
	scrollSceneElem.push('.style-1 .vertical-title', '.style-1 .txt');

	var tween = new TimelineMax ()
	.add([
		TweenMax.fromTo(".style-2 .vertical-title", {y:-50, opacity:0}, {y: 0, opacity:1, duration:1, ease: Linear.easeNone}),
	])
	.add([
		TweenMax.fromTo(".style-2 .txt", {opacity:0}, {opacity:1, duration:1, ease: Linear.easeNone}),
	], "-=0.1")
	.add([
		TweenMax.fromTo(".style-2 .row-1", {opacity:0}, {opacity:1, duration:1, ease: Linear.easeNone}),
	], "-=0.1")
	.add([
		TweenMax.fromTo(".style-2 .row-2", {opacity:0}, {opacity:1, duration:1, ease: Linear.easeNone}),
	], "-=0.1")

	var scene = new ScrollMagic.Scene({
		triggerElement: ".style-2",
		triggerHook: .8,
		duration: "50%",
	})
	.setTween(tween)
	.addTo(scrollMagicController);

	scrollScene.push(scene);
	scrollSceneElem.push('.style-2 .vertical-title', '.style-2 .txt', '.style-2 .row-1', '.style-2 .row-2');
}

function mobileScrollMagic(){
	scrollMagicController = new ScrollMagic.Controller();

	var tween = new TimelineMax ()
	.add([
		TweenMax.fromTo(".inner-banner", {y:0}, {y: "-50%", duration:1, ease: Linear.easeNone}),
	])

	var scene = new ScrollMagic.Scene({
		triggerElement: "main",
		triggerHook: 0,
		duration: "100%",
	})
	.setTween(tween)
	.addTo(scrollMagicController);

	scrollScene.push(scene);
	scrollSceneElem.push('.inner-banner');

	var tween = new TimelineMax ()
	.add([
		TweenMax.fromTo(".style-1 .vertical-title", {y:-25, opacity:0}, {y: 0, opacity:1, duration:1, ease: Linear.easeNone}),
	])
	.add([
		TweenMax.fromTo(".style-1 .txt", {opacity:0}, {opacity:1, duration:1, ease: Linear.easeNone}),
	], "-=0.1")

	var scene = new ScrollMagic.Scene({
		triggerElement: ".style-1",
		triggerHook: .8,
		duration: "60%",
	})
	.setTween(tween)
	.addTo(scrollMagicController);

	scrollScene.push(scene);
	scrollSceneElem.push('.style-1 .vertical-title', '.style-1 .txt');

	var tween = new TimelineMax ()
	.add([
		TweenMax.fromTo(".style-2 .vertical-title", {y:-25, opacity:0}, {y: 0, opacity:1, duration:1, ease: Linear.easeNone}),
	])
	.add([
		TweenMax.fromTo(".style-2 .txt", {opacity:0}, {opacity:1, duration:1, ease: Linear.easeNone}),
	], "-=0.1")
	.add([
		TweenMax.fromTo(".style-2 .row-1", {opacity:0}, {opacity:1, duration:1, ease: Linear.easeNone}),
	], "-=0.1")
	.add([
		TweenMax.fromTo(".style-2 .row-2", {opacity:0}, {opacity:1, duration:1, ease: Linear.easeNone}),
	], "-=0.1")

	var scene = new ScrollMagic.Scene({
		triggerElement: ".style-2",
		triggerHook: .8,
		duration: "60%",
	})
	.setTween(tween)
	.addTo(scrollMagicController);

	scrollScene.push(scene);
	scrollSceneElem.push('.style-2 .vertical-title', '.style-2 .txt', '.style-2 .row-1', '.style-2 .row-2');
}


if(viewportEffect == 'desktop'){
	desktopScrollMagic();
}else{
	mobileScrollMagic();
}

$(window).on('resize', function(){
	if(viewportEffect != (viewport().width >= 992 ? 'desktop' : 'mobile')){
		viewportEffect = (viewport().width >= 992 ? 'desktop' : 'mobile');
		if(scrollMagicController){
			scrollMagicController.destroy(true);
			scrollMagicController = null;
			if(scrollScene) scrollScene.forEach(item => item.destroy(true));
			scrollScene = [];
			if(scrollSceneElem) scrollSceneElem.forEach(item => $(item).removeAttr('style'));
			scrollSceneElem = [];
		}
		if(viewportEffect == 'desktop'){
			desktopScrollMagic();
		}else{
			mobileScrollMagic();
		}
	}
})













